const isLinkWithHref = (element) =>
  !!element && element.nodeName === 'A' && element.hasAttribute('href');

export default isLinkWithHref;
